<template>
    <div id='PsNotificationList'>
        <div class="PsNotificationHeader"><span>Notifications</span></div>
        <PsNotificationItem v-for='(notification, idx) in notifications.slice().reverse()'
            :key='idx'
            :name='notification.message'
            :link='notification.link'
            :time='notification.timeStamp'
            :type='notification.type'
            :notificationObject='notification'
            @remove-notification = remove
        >
            
        </PsNotificationItem>
        <div class='AllNotifications'>
            <button class='btn btn-primary btn-clear-all' @click="clearAll">Clear</button>
        </div>
    </div>
</template>
<script>
    import PsNotificationItem from './PsNotificationItem';
    export default{
        name: 'PsNotificationList',
        props:['notifications'],
        components:{
            PsNotificationItem
        },
        /*created(){
            return {
                timeStarted: Date.now()
            }
        },*/
        data(){
            return{
                notificationList: this.$props.notifications,
                timeStarted: Date.now()
            }
        },
        methods:{
            remove(removedNotification){
                //console.log("button pressed: " +removedNotification )

                this.$store.dispatch('Navigation/removeNotification', removedNotification)
                .then(() => {
                    if(this.$props.notifications.length == 0){
                        this.$emit('re-enable-scroll');
                    }
                });
            },
            clearAll(){
                this.$props.notifications.forEach(notification => {
                    this.remove(notification);
                    this.$emit('re-enable-scroll');
                });
            }
        }
    }
</script>
